/*
Author: Liubo
Date: 2018-09-05
Desc: 框架配置文件
*/
import env from "./env";
import dyna from "./dyna_router";

const conf = Object.assign(env, dyna);
if (conf.session_mode === "2") {
    // 如果session_mode为2，则移除_session 配置
    let ary = [];
    for (let item of conf.cache) {
        if (item.code !== "_session") {
            ary.push(item);
        }
    }
    conf.cache = ary;
}
export default conf;
